import { render, staticRenderFns } from "./CataloguesTable.vue?vue&type=template&id=ed31f1fa&scoped=true"
import script from "./CataloguesTable.vue?vue&type=script&lang=js"
export * from "./CataloguesTable.vue?vue&type=script&lang=js"
import style0 from "./CataloguesTable.vue?vue&type=style&index=0&id=ed31f1fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed31f1fa",
  null
  
)

export default component.exports